import React, { useState } from 'react';
import { Button, Input, Modal } from '../../../../ui';
import { InputAdornment } from '@mui/material';

const MINIMUM_AMOUNT = 0.5;

interface OtherAmountModalProps {
    open: boolean;
    onSubmit: (value: number) => unknown;
    onClose: () => unknown;
}

const OtherAmountModal: React.FC<OtherAmountModalProps> = ({
    open,
    onClose,
    onSubmit,
}) => {
    const [amount, setAmount] = useState<number | undefined>();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setAmount(parseFloat(value) || undefined);
    };

    const handleSubmit = () =>
        amount && amount >= MINIMUM_AMOUNT && onSubmit(amount);

    return (
        <Modal
            open={open}
            onClose={(_, reason) => reason !== 'backdropClick' && onClose()}
        >
            <div className="flex flex-col gap-4 align-middle justify-center w-[412px] mobile:w-full">
                <div className="text-body-medium-bold">Enter dollar amount</div>
                <div className="other-amount-text-field">
                    <Input
                        value={amount}
                        onChange={handleChange}
                        id="other-amount-number"
                        autoFocus
                        type="number"
                        placeholder="Amount"
                        maxLength={7}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        $
                                    </InputAdornment>
                                ),
                            },
                        }}
                    />
                </div>
                <Button
                    disabled={amount === undefined || amount < MINIMUM_AMOUNT}
                    onClick={handleSubmit}
                    className="w-full"
                >
                    OK
                </Button>
            </div>
        </Modal>
    );
};

export default OtherAmountModal;
